module.exports = __webpack_public_path__ + "img/question_ts_2.42cedeee.gif";